var identity = identity || {};

identity.deferImages = {
    settings: {
        deferClass: 'js-e-content-defer',
        preloadClass: 'e-content-defer-placeholder',
        loadingClass: 'is-deferred',
        loadedClass: 'has-loaded',
        backgroundTags: [
            'div',
            'span'
        ],
        observerOptions: {
            rootMargin: '400px 320px'
        }
    },
    utils: {
        isBackgroundTag: function (domElmTag) {
            return identity.deferImages.settings.backgroundTags.indexOf(domElmTag) > -1;
        },
        getClosestSrcSetSize: function (strDataSrcset) {
            //polyfill for fallback srcset
            var intMaxWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width,
                intMaxHeight = (window.innerHeight > 0) ? window.innerHeight : screen.height,
                intMaxDensity = window.devicePixelRatio || 1,
                arrSrcsetCandidates = strDataSrcset.split(',');

            for (var i = 0; i < arrSrcsetCandidates.length; i++) {

                // The following regular expression was created based on the rules
                // in the srcset W3C specification available at:
                // http://www.w3.org/html/wg/drafts/srcset/w3c-srcset/
                var descriptors = arrSrcsetCandidates[i].match(
                    /^\s*([^\s]+)\s*(\s(\d+)w)?\s*(\s(\d+)h)?\s*(\s(\d+)x)?\s*$/
                    ),
                    strFilename = descriptors[1],
                    intWidth = descriptors[3] || false,
                    intHeight = descriptors[5] || false,
                    intDensity = descriptors[7] || 1;

                if (intWidth && intWidth < intMaxWidth) {
                    continue;
                }

                if (intHeight && intHeight < intMaxHeight) {
                    continue;
                }

                if (intDensity && intDensity > intMaxDensity) {
                    continue;
                }
                return strFilename;
            }
        },
        getElements: function () {
            return jQuery('.' + identity.deferImages.settings.deferClass).not('.defer-bound').toArray();
        }
    },
    init: function () {
        identity.deferImages.event = e4.util.registerEvents('loaded', 'deferImages');
        var arrDomElementsToDefer = identity.deferImages.utils.getElements(),
            arrSvgElementToLoad = jQuery('img.svg').not('.defer-bound').toArray();

        arrDomElementsToDefer.concat(arrSvgElementToLoad).forEach(function(deferImage){
            jQuery(deferImage).addClass('defer-bound');
        });
        
        if(arrSvgElementToLoad.length > 0){
            e4.util.observer.bind(arrSvgElementToLoad, identity.deferImages.onSvgIntersection, e4.settings.ecom.lazyload.observerOptions);
        }
        
        if (arrDomElementsToDefer.length > 0) {
            e4.util.observer.bind(arrDomElementsToDefer, identity.deferImages.onElementIntersection, identity.deferImages.settings.observerOptions);
        }
    },
    onSvgIntersection: function(objEntry, objObserver){
        if (objEntry.isIntersecting === true) {
            
            var jImage = jQuery(objEntry.target),
                strImgID = jImage.attr('id'),
                strImgClass = jImage.attr('class'),
                strImgURL = jImage.attr('src'),
                deferredImage = identity.deferImages.convertSvg(strImgURL, strImgID, strImgClass);
                
            jQuery.when(deferredImage).done(function (jSvg) {
                jImage.replaceWith(jSvg);
                objObserver.unobserve(objEntry.target);
            });
        }
    },
    onElementIntersection: function (domElm, observer) {
        if (domElm.isIntersecting === true) {
            var domElmTarget = domElm.target,
                domElmTag = domElmTarget.tagName.toLowerCase(),
                strDataSrc = jQuery(domElmTarget).data('src'),
                strDataSrcset = jQuery(domElmTarget).data('srcset');
            if (domElmTag === 'img') {
                identity.deferImages.setImageSrc(domElmTarget, strDataSrc, strDataSrcset);
            } else if (identity.deferImages.utils.isBackgroundTag(domElmTag) === true) {
                identity.deferImages.setImageBackgroundSrc(domElmTarget, strDataSrc, strDataSrcset);
            } else if (domElmTag === 'video') {
                identity.deferImages.setVideoSrc(domElmTarget);
            } else if (domElmTag === 'iframe') {
                identity.deferImages.setIframeSrc(domElmTarget, strDataSrc);
            } else {
                console.warn('Not a valid lazyload tag: ' + domElmTag);
            }
            observer.unobserve(domElmTarget);
        }
    },
    setImageSrc: function (domElmTarget, strDataSrc, strDataSrcset) {
        identity.deferImages.loadTarget(domElmTarget, identity.deferImages.showLoadedTarget);
        if (strDataSrcset !== undefined) {
            jQuery(domElmTarget).attr('srcset', strDataSrcset);
        } else {
            jQuery(domElmTarget).attr('src', strDataSrc);
        }
    },
    setImageBackgroundSrc: function (domElmTarget, strDataSrc, strDataSrcset) {
        if (strDataSrcset !== undefined) {
            var strClosestSrcsetMatch = identity.deferImages.utils.getClosestSrcSetSize(strDataSrcset);
            if (strClosestSrcsetMatch) {
                jQuery(domElmTarget).css('background-image', 'url(' + strClosestSrcsetMatch + ')');
            } else{
                jQuery(domElmTarget).css('background-image', 'url(' + strDataSrc + ')');
            }
        } else {
            jQuery(domElmTarget).css('background-image', 'url(' + strDataSrc + ')');
        }
        identity.deferImages.showLoadedTarget(domElmTarget);
    },
    setVideoSrc: function (domElmTarget) {
        domElmTarget.load();
        identity.deferImages.showLoadedTarget(domElmTarget);
    },
    setIframeSrc: function (domElmTarget, strDataSrc) {
        identity.deferImages.loadTarget(domElmTarget, identity.deferImages.showLoadedTarget);
        jQuery(domElmTarget).attr('src', strDataSrc);
    },
    loadTarget: function (domElmTarget, fnCallback) {
        jQuery(domElmTarget).one('load', function () {
            if (typeof fnCallback === 'function') {
                fnCallback(domElmTarget);
            }
            setTimeout(function(){
                jQuery(document).trigger('loaded.e4.deferImages', domElmTarget);
            }, 100);
        });
    },
    showLoadedTarget: function (domElmTarget) {

        if (identity.deferImages.settings.loadedClass !== '' && domElmTarget.classList.contains(identity.deferImages.settings.loadingClass) === true) {
            jQuery(domElmTarget).addClass(identity.deferImages.settings.loadedClass);
        }
        jQuery(domElmTarget).removeClass([
            identity.deferImages.settings.preloadClass,
            identity.deferImages.settings.deferClass
        ].join(' '));
        
    },
    convertSvg: function(strImageSrc, strImgID, strImgClass){
        var deferred = jQuery.Deferred();
        jQuery.get(strImageSrc, function (data) {
            var jSvg = jQuery(data).find('svg');
            if (typeof strImgID !== 'undefined') {
                jSvg = jSvg.attr('id', strImgID);
            }
            if (typeof strImgClass !== 'undefined') {
                jSvg = jSvg.attr('class', strImgClass + ' replaced-svg');
            }
            jSvg = jSvg.removeAttr('xmlns:a');
            deferred.resolve(jSvg);
        }, 'xml');
        return deferred.promise();
    }
};
